import convertLinkToImage from '~/app/utils/convertLinkToImage';
import isIntersectionObserverSupported from '~/app/utils/isIntersectionObserverSupported';

/**
 * Инициализирует ленивые изображения.
 * 
 * Превращение ссылок на изображения, с классом `lazy-image`, в изображения.
 */
function main(): void
{
	const links = new Set<HTMLAnchorElement>(
		Array.from(
			document.querySelectorAll( 'a.lazy-image' ) as
				NodeListOf<HTMLAnchorElement>,
		),
	);
	
	if ( !isIntersectionObserverSupported() )
	{
		links.forEach(
			( element ) =>
			{
				convertLinkToImage( element );
			},
		);
		
		return;
	}
	
	const onIntersection = ( entries: IntersectionObserverEntry[] ) =>
	{
		for ( const entry of entries )
		{
			if ( !(entry as any).isIntersecting )
			{
				continue;
			}
			
			const element = entry.target as HTMLAnchorElement;
			
			convertLinkToImage( element );
			observer.unobserve( element );
		}
	};
	
	const observer = new IntersectionObserver( onIntersection );
	
	links.forEach(
		( element ) =>
		{
			observer.observe( element );
			links.delete( element );
		},
	);
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/LazyImage/index.ts